import { Icon } from "@clarkinc/zest-design-system";
import ct from "class-types.macro";
import React, { FormEvent, useRef } from "react";
import Button from "~/common/Buttons";
import { inputBase } from "~/common/Form/inputStyles";
import encodeAndSanitizeSearchQuery from "~/common/helpers/encodeAndSanitizeSearchQuery";
import { BlogCategory } from "../BlogHeader/BlogHeader";
interface Props {
  latestCouponPostUrl: string | undefined;
  categories: BlogCategory[];
}
export default function BlogSidebar({
  latestCouponPostUrl,
  categories
}: Props) {
  const searchTermField = useRef<HTMLInputElement>(null);
  const onSubmitSearch = (event: FormEvent) => {
    event.preventDefault();
    if (searchTermField.current === null) {
      return;
    }
    const term = encodeAndSanitizeSearchQuery(searchTermField.current.value);
    if (term.length > 0) {
      window.location.href = `/blog/search/${term}/`;
    }
  };
  return <div id="sidebar-wrapper" data-sentry-component="BlogSidebar" data-sentry-source-file="BlogSidebar.tsx">
      <form onSubmit={onSubmitSearch}>
        <div className={ct("flex", "m-5", "mb-0")}>
          <div className={ct("flex-auto")} style={{
          zIndex: 1
        }}>
            <div className={ct("pb-6", "relative")}>
              <input ref={searchTermField} name="searchTerm" placeholder="Search" type="text" className={inputBase} style={{
              height: "42px",
              fontSize: "20px"
            }} id="searchTerm" />
            </div>
          </div>
          <div className={ct("flex-initial")} style={{
          zIndex: 2,
          marginLeft: -4
        }}>
            <Button type="submit" color="custom" size="custom" className={ct("bg-green-400", "hover:bg-green-500", "border-green-500", "rounded-l-none", "rounded-r", "text-base", "px-4", "py-2-1/2", "text-white")} style={{
            height: 42
          }} title="Search Blog" data-sentry-element="Button" data-sentry-source-file="BlogSidebar.tsx">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-sentry-element="svg" data-sentry-source-file="BlogSidebar.tsx">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" data-sentry-element="path" data-sentry-source-file="BlogSidebar.tsx" />
              </svg>
            </Button>
          </div>
        </div>
      </form>
      <ul className="sidebar-nav">
        <li>Categories</li>
        {latestCouponPostUrl && <li>
            <a href={latestCouponPostUrl} className="special-category" title="Coupon Codes">
              <Icon name="ri-scissors-line" className="fill-current	w-4 h-4 align-sub mr-1" />
              Coupon Codes
            </a>
          </li>}
        <li>
          <a href="/blog/archives.cfm" className="special-category" title="Archives">
            <Icon name="ri-history-line" className="fill-current w-4 h-4 align-sub mr-1" data-sentry-element="Icon" data-sentry-source-file="BlogSidebar.tsx" />
            Archives
          </a>
        </li>

        {categories.map(category => <li key={`blog-category-${category.name}`}>
            <a href={category.url} title={category.name}>
              {category.name}
              <span className="pull-right">({category.count})</span>
            </a>
          </li>)}
      </ul>
    </div>;
}